import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { logPageView } from '../services/analytics/analytics';

/**
 * Listens for route changes and logs page views to Firebase Analytics
 */
const AnalyticsListener = () => {
  const location = useLocation();

  useEffect(() => {
    logPageView(location.pathname + location.search);
  }, [location]);

  return null;
};

export default AnalyticsListener;
